import { type Notification } from '@/types/notifications';

export enum NotificationType {
  ShareExpired = 'ShareExpired',
  ArchiveReady = 'ArchiveReady',
  InvitationAccepted = 'InvitationAccepted',
  UploadComplete = 'UploadComplete',
  Welcome = 'Welcome',
  CommentResolved = 'CommentResolved',
  CommentCreated = 'CommentCreated',
  ShareCreated = 'ShareCreated',
}

export const isNotificationType = (notification: Notification, type: NotificationType) =>
  notification.type === type || notification.type === `App\\Notifications\\${type}Notification`;

export const shouldToastNotification = (notification: Notification) =>
  [
    NotificationType.ShareExpired,
    NotificationType.ArchiveReady,
    NotificationType.CommentResolved,
    NotificationType.CommentCreated,
  ].some((type) => isNotificationType(notification, type));
